export default function Marquee({ items, className = "" }) {
  return (
    <div
      className={`marquee-hover relative overflow-hidden ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-6">{item}</span>
                <span className="text-terra" aria-hidden="true">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
                    <circle cx="5" cy="5" r="5" />
                  </svg>
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
